import React from 'react';

interface ResearchItem {
    id: string;
    title: string;
    excerpt: string;
    category: string;
    image?: string;
    link: string;
}

interface ResearchCardProps {
    items: ResearchItem[];
    className?: string;
}

export const ResearchCard: React.FC<ResearchCardProps> = ({
    items,
    className = '',
}) => {
    return (
        <div className={`researcher-cards ${className}`}>
            {items.map((item) => (
                <a
                    key={item.id}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="researcher-card"
                >
                    {item.image && (
                        <img
                            src={item.image}
                            alt={item.title}
                            className="researcher-card-image"
                            loading="lazy"
                        />
                    )}

                    <div className="researcher-card-content">
                        <div className="researcher-card-category">{item.category}</div>
                        <h3 className="researcher-card-title">{item.title}</h3>
                        <p className="researcher-card-excerpt">{item.excerpt}</p>
                    </div>
                </a>
            ))}
        </div>
    );
};

export default ResearchCard;
